export var ChartAxisType;
(function (ChartAxisType) {
    ChartAxisType["Number"] = "number";
    ChartAxisType["Category"] = "category";
})(ChartAxisType || (ChartAxisType = {}));
export var ChartSeriesType;
(function (ChartSeriesType) {
    ChartSeriesType["Bar"] = "Bar";
    ChartSeriesType["Line"] = "Line";
    ChartSeriesType["HeatMap"] = "HeatMap";
})(ChartSeriesType || (ChartSeriesType = {}));
export var ColumnType;
(function (ColumnType) {
    ColumnType["Categorical"] = "Categorical";
    ColumnType["Numeric"] = "Numeric";
    ColumnType["DateTime"] = "DateTime";
})(ColumnType || (ColumnType = {}));
export var OutcomeType;
(function (OutcomeType) {
    OutcomeType["Count"] = "Count";
    OutcomeType["Binary"] = "Binary";
    OutcomeType["Numeric"] = "Numeric";
})(OutcomeType || (OutcomeType = {}));
